import normalizeError from '../../utils/normalizeError';
import instance from '../scorpiusInstance';
import {
  CREATE_APP_USER_START,
  CREATE_APP_USER_SUCCESS,
  CREATE_APP_USER_ERROR,
} from '../types';

export const createAppUserStart = (orgId, appName) => ({
  type: CREATE_APP_USER_START,
  orgId,
  appName,
});

export const createAppUserSuccess = (
  orgId,
  appName,
  user,
  resentInvite = false,
) => ({
  type: CREATE_APP_USER_SUCCESS,
  orgId,
  appName,
  user,
  resentInvite,
});

export const createAppUserError = (orgId, appName, error) => ({
  type: CREATE_APP_USER_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Creates the user for the given organization's app.
 * @param {String} orgId
 * @param {String} appName
 * @param {Object} user
 * @param {String} user.email
 * @param {String} user.first_name
 * @param {String} user.last_name
 * @param {String} user.role
 */
export const createAppUser = (orgId, appName, user) => async dispatch => {
  dispatch(createAppUserStart(orgId, appName));
  try {
    const resp = await instance.post(
      `/organizations/${orgId}/${appName}/users`,
      user,
      {
        headers: { retry: true },
      },
    );
    const resentInvite = resp.status === 200;
    return dispatch(createAppUserSuccess(orgId, appName, user, resentInvite));
  } catch (error) {
    throw dispatch(createAppUserError(orgId, appName, normalizeError(error)));
  }
};

export default createAppUser;
